import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMorehoriz(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.518 12q0-.721.514-1.236a1.69 1.69 0 0 1 1.236-.514q.721 0 1.236.514.514.514.514 1.236 0 .721-.514 1.236a1.69 1.69 0 0 1-1.236.514q-.721 0-1.236-.514A1.69 1.69 0 0 1 2.518 12m7.726 0q0-.721.514-1.236a1.69 1.69 0 0 1 1.236-.514q.721 0 1.236.514.514.514.514 1.236 0 .721-.514 1.236a1.69 1.69 0 0 1-1.236.514q-.722 0-1.236-.514A1.69 1.69 0 0 1 10.244 12m7.736 0q0-.721.514-1.236a1.69 1.69 0 0 1 1.236-.514q.722 0 1.236.514T21.48 12t-.514 1.236a1.69 1.69 0 0 1-1.236.514q-.722 0-1.236-.514A1.69 1.69 0 0 1 17.98 12"
  }));
}
var IcMorehoriz = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMorehoriz));

export { IcMorehoriz as I };
